import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=55f88310&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "./Tab.vue?vue&type=style&index=0&id=55f88310&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f88310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f88310')) {
      api.createRecord('55f88310', component.options)
    } else {
      api.reload('55f88310', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=55f88310&scoped=true", function () {
      api.rerender('55f88310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cas/components/Tab.vue"
export default component.exports